import { render, staticRenderFns } from "./AssetLocalisationWidgetComponent.vue?vue&type=template&id=4a66cd8e&"
import script from "./AssetLocalisationWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./AssetLocalisationWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports